import { useEffect, useState } from 'react'

/**
 * A tela de carregamento sai quando a pagina termina de carregar. O timer de
 * 2,5s e rede de seguranca: se um recurso externo nunca responder, o evento
 * load nao dispara e a pagina ficaria coberta para sempre.
 */
export function usePreloader() {
  const [carregado, setCarregado] = useState(false)

  useEffect(() => {
    const liberar = () => setCarregado(true)
    const aoCarregar = () => window.setTimeout(liberar, 320)

    window.addEventListener('load', aoCarregar)
    const seguranca = window.setTimeout(liberar, 2500)

    return () => {
      window.removeEventListener('load', aoCarregar)
      window.clearTimeout(seguranca)
    }
  }, [])

  useEffect(() => {
    document.body.classList.toggle('is-loaded', carregado)
  }, [carregado])

  return carregado
}
